import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import Home from './pages/Home'
import Playlist from './pages/Playlist'
import CaseStudy from './pages/PropelCaseStudy'
import PlasticBeachCaseStudy from './pages/PlasticBeachCaseStudy'
import WCASLCaseStudy from './pages/WCASLCaseStudy'
import About from './pages/About'
import ClickSpark from './components/ui/ClickSpark'

function App() {
  return (
    <BrowserRouter>
      <ClickSpark />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/playlist" element={<Playlist />} />
        <Route path="/case-study" element={<CaseStudy />} />
        <Route path="/case-study/plastic-beach" element={<PlasticBeachCaseStudy />} />
        <Route path="/case-study/wcasl" element={<WCASLCaseStudy />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  )
}

export default App
